import { APP_INITIALIZER, NgModule, provideZoneChangeDetection } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';
import { QuillModule } from 'ngx-quill';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CertificationTemplateEditorComponent } from '../components/product-certification/certifications/certifications/certification-template-editor/certification-template-editor.component';
import { TemplateNodeEditorComponent } from '../components/product-certification/certifications/certifications/certification-template-editor/template-node-editor/template-node-editor.component';
import { TemplateTreeViewerComponent } from '../components/product-certification/certifications/certifications/certification-template-editor/template-tree-viewer/template-tree-viewer.component';

//Produktliste
import { ProductListComponent } from '../components/product-list/product-list.component';

import { DigitOnlyDirective } from '../directives/digit-only.directive';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AttributeTableComponent } from '../components/attributes/attribute-tables/attribute-table/attribute-table.component';
import { CommonFeatureAddComponent } from '../components/common-feature/common-feature-add/common-feature-add.component';
import { CommonFeatureItemEditFormComponent } from '../components/common-feature/common-feature-item-edit-form/common-feature-item-edit-form.component';
import { CommonFeatureItemComponent } from '../components/common-feature/common-feature-item/common-feature-item.component';
import { ComposerProductFilterElementComponent } from '../components/composer/composer-product-filter-element/composer-product-filter-element.component';
import { ComposerProductOverviewComponent } from '../components/composer/composer-product-overview/composer-product-overview.component';
import { DialogAddProductToNodeComponent } from '../components/composer/dialog-add-product-to-node/dialog-add-product-to-node.component';
import { DialogEditMetaDataComponent } from '../components/composer/model-editor/dialog-edit-meta-data/dialog-edit-meta-data.component';
import { ModelEditorComponent } from '../components/composer/model-editor/model-editor.component';
import { DialogCommonFeatureProductCreationComponent } from '../components/dialog-windows/dialog-common-feature-product-creation/dialog-common-feature-product-creation.component';
import { FilemanagerComponent } from '../components/dialog-windows/dialog-file-manager/file-manager.component';
import { DialogRequestComponent } from '../components/dialog-windows/dialog-request/dialog-request.component';
import { DialogCertRequestComponent } from '../components/dialog-windows/dialog-request/dialog-certRequest.component';

import { MalfunctionOverviewOrganisationComponent } from '../components/malfunction/malfunction-overview-organisation/malfunction-overview-organisation.component';
import { MalfunctionOverviewComponent } from '../components/malfunction/malfunction-overview/malfunction-overview.component';
import { ReportMalfunctionScreenComponent } from '../components/malfunction/report-malfunction-screen/report-malfunction-screen.component';
import { CertificationDetailDisplayCriteriaComponent } from '../components/marketplace/detail-pages/certification-detail-display/certification-detail-display-criteria/certification-detail-display-criteria.component';
import { CertificationDetailDisplayOrganisationComponent } from '../components/marketplace/detail-pages/certification-detail-display/certification-detail-display-organisation/certification-detail-display-organisation.component';
import { CertificationDetailDisplayOverviewComponent } from '../components/marketplace/detail-pages/certification-detail-display/certification-detail-display-overview/certification-detail-display-overview.component';
import { CertificationDetailDisplayComponent } from '../components/marketplace/detail-pages/certification-detail-display/certification-detail-display.component';
import { CertificationDetailDisplayCertifiedProductsComponent } from '../components/marketplace/detail-pages/certification-detail-display/certified-products/certification-certified-products.component';
import { CertificationDetailDisplayCertifiedOrganisationsComponent } from '../components/marketplace/detail-pages/certification-detail-display/certified-organisations/certification-certified-organisations.component';
import { CertificationDetailDisplayTypeOverviewComponent } from '../components/marketplace/detail-pages/certification-detail-display/certification-detail-display-type-overview/certification-detail-display-type-overview.component';
import { OrganisationDetailDisplayComponent } from '../components/marketplace/detail-pages/organisation-detail-display/organisation-detail-display.component';
import { ProductDetailDisplayCertificatesComponent } from '../components/marketplace/detail-pages/product-detail-display/product-detail-display-certificates/product-detail-display-certificates.component';
import { ProductDetailDisplayCommonFeaturesComponent } from '../components/marketplace/detail-pages/product-detail-display/product-detail-display-feature/product-detail-display-common-features/product-detail-display-common-features.component';
import { ProductDetailDisplayDownloadsComponent } from '../components/marketplace/detail-pages/product-detail-display/product-detail-display-downloads/product-detail-display-downloads.component';
import { ProductDetailDisplayFeatureComponent } from '../components/marketplace/detail-pages/product-detail-display/product-detail-display-feature/product-detail-display-feature.component';
import { ProductDetailDisplayOrganisationComponent } from '../components/marketplace/detail-pages/product-detail-display/product-detail-display-organisation/product-detail-display-organisation.component';
import { ProductDetailDisplayOverviewComponent } from '../components/marketplace/detail-pages/product-detail-display/product-detail-display-overview/product-detail-display-overview.component';
import { ProductDetailDisplayComponent } from '../components/marketplace/detail-pages/product-detail-display/product-detail-display.component';
import { DetailDisplayAdressDisplayComponent } from '../components/marketplace/detail-pages/subcomponents/detail-display-adress-display/detail-display-adress-display.component';
import { DetailDisplayContactDisplayComponent } from '../components/marketplace/detail-pages/subcomponents/detail-display-contact-display/detail-display-contact-display.component';
import { DetailDisplayDocumentListComponent } from '../components/marketplace/detail-pages/subcomponents/detail-display-document-list/detail-display-document-list.component';
import { DetailDisplayGalleryComponent } from '../components/marketplace/detail-pages/subcomponents/detail-display-gallery/detail-display-gallery.component';
import { DetailDisplayHeaderComponent } from '../components/marketplace/detail-pages/subcomponents/detail-display-header/detail-display-header.component';
import { CommentItemComponent } from '../components/marketplace/detail-pages/subcomponents/marketplace-rating-extended/comment-item/comment-item.component';
import { CommentTableComponent } from '../components/marketplace/detail-pages/subcomponents/marketplace-rating-extended/comment-table/comment-table.component';
import { MarketplaceRatingExtendedComponent } from '../components/marketplace/detail-pages/subcomponents/marketplace-rating-extended/marketplace-rating-extended.component';
import { ReviewTableComponent } from '../components/marketplace/detail-pages/subcomponents/marketplace-rating-extended/review-table/review-table.component';
import { CertificateMiniDisplayComponent } from '../components/marketplace/display-item/certificate-mini-display/certificate-mini-display.component';
import { CertificateSimpleDisplayComponent } from '../components/marketplace/display-item/certificate-simple-display/certificate-simple-display.component';
import { DisplayItemComponent } from '../components/marketplace/display-item/display-item.component';
import { MarketplaceOverviewComponent } from '../components/marketplace/marketplace-overview.component';
import { AssetPropertiesDialogComponent } from '../components/marketplace/subcomponents/asset-properties-dialog/asset-properties-dialog.component';
import { HmtlDisplayComponent } from '../components/miscellaneous/hmtl-display/hmtl-display.component';
import { ProfilePictureComponent } from '../components/miscellaneous/profile-picture/profile-picture.component';
import { TextEditorComponent } from '../components/miscellaneous/text-editor/text-editor.component';
import { OrganisationContactOverviewComponent } from '../components/organisation-user-settings/views-organisation-management/contact-components/organisation-contact-overview/organisation-contact-overview.component';
import { VersionEditComponent } from '../components/product-certification/shared-subcomponents/version-edit/version-edit.component';
import { PasswordStrengthComponent } from '../components/registration-login/password-strength/password-strength.component';
import { FileDropDirective } from '../directives/file-drop.directive';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragulaModule } from 'ng2-dragula';
import { AttributeCatalogueComponent } from '../components/attributes/attribute-tables/attribute-catalogue/attribute-catalogue.component';
import { AttributeSelectTableComponent } from '../components/attributes/attribute-tables/attribute-select-table/attribute-select-table.component';
import { AttributeValidationTableComponent } from '../components/attributes/attribute-tables/attribute-validation-table/attribute-validation-table.component';
import { AttributeValidationPanelComponent } from '../components/attributes/attribute-tables/attribute-validation-panel/attribute-validation-panel.component';
import { PtgAttributeCatalogueComponent } from '../components/attributes/attribute-tables/ptg-attribute-catalogue/ptg-attribute-catalogue.component';
import { AttributeValidationComponent } from '../components/attributes/attribute-validation/attribute-validation.component';
import { HexLabelButtonComponent } from '../components/buttons/hex-label-button/hex-label-button.component';
import { HexagonButtonTextIconComponent } from '../components/buttons/hexagon-button-text-icon/hexagon-button-text-icon.component';
import { RedCrossButtonComponent } from '../components/buttons/red-cross-button/red-cross-button.component';
import { RedCrossButtonCircleComponent } from '../components/buttons/red-cross-button-circle/red-cross-button-circle.component';
import { RedTrashCanButtonComponent } from '../components/buttons/red-trash-can-button/red-trash-can-button.component';
import { RoundedButtonComponent } from '../components/buttons/rounded-button/rounded-button.component';
import { SquaredButtonComponent } from '../components/buttons/squared-button/squared-button.component';
import { GreenPlusButtonComponent } from '../components/buttons/green-plus-button/green-plus-button.component';
import { ToggleSwitchComponent } from '../components/buttons/toggle-switch/toggle-switch.component';
import { CheckboxSwitchComponent } from '../components/buttons/checkbox-switch/checkbox-switch.component';
import { DialogAttributeCreate } from '../components/dialog-windows/dialog-attribute-create';
import { DialogConfirmComponent } from '../components/dialog-windows/dialog-confirm.component';
import { DialogFileManagerComponent } from '../components/dialog-windows/dialog-filemanager.component';
import { DialogOverviewExampleDialogComponent } from '../components/dialog-windows/dialog-overview-example-dialog.component';
import { DialogRemoveMemberConfirmComponent } from '../components/dialog-windows/dialog-remove-member-confirm/dialog-remove-member-confirm.component';
import { DialogText } from '../components/dialog-windows/dialog-text';
import { DialogAgb } from '../components/dialog-windows/dialog-agb-text/dialog-agb';
import { DialogAboVerwaltungComponent } from '../components/dialog-windows/dialog-abo-verwaltung/dialog-abo-verwaltung.component';
import { DialogPrivacy } from '../components/dialog-windows/dialog-privacy-text/dialog-privacy';
import { DialogLoginComponent } from '../components/dialog-windows/dialog-login/dialog-login.component';
import { AttributeOverviewComponent } from '../components/attributes/attribute-overview-component/attribute-overview-component';
import { DialogErrorComponent } from '../components/dialog-windows/dialog-error/dialog-error.component';
import { ProductSummaryComponent } from '../components/product-certification/products/products/product-summary/product-summary.component';

import { TriangleIndentComponent } from '../components/icons/triangle-indent/triangle-indent.component';
import { ValidationIconComponent } from '../components/icons/validation-icon/validation-icon.component';
import { WriteCommentComponent } from '../components/marketplace/detail-pages/subcomponents/marketplace-rating-extended/write-comment/write-comment.component';
import { InfiniteScrollComponent } from '../components/marketplace/subcomponents/infinite-scroll/infinite-scroll.component';
import { MarketplaceCategorySwitchComponent } from '../components/marketplace/subcomponents/marketplace-category-switch/marketplace-category-switch.component';
import { MarketplaceProductRondellComponent } from '../components/marketplace/subcomponents/marketplace-product-rondell/marketplace-product-rondell.component';
import { MarketplaceProducthexagonComponent } from '../components/marketplace/subcomponents/marketplace-producthexagon/marketplace-producthexagon.component';
import { MarketPlaceSideFilterComponent } from '../components/marketplace/subcomponents/marketplace-side-filter/market-place-side-filter.component';
import { MarketplaceSideimagehexagonComponent } from '../components/marketplace/subcomponents/marketplace-sideimagehexagon/marketplace-sideimagehexagon.component';
import { FooterComponent } from '../components/miscellaneous/footer/footer.component';
import { HexLabelItemComponent } from '../components/miscellaneous/hex-label-item/hex-label-item.component';
import { HexagonComponent } from '../components/miscellaneous/hexagon/hexagon.component';
import { SecureImageComponent } from '../components/miscellaneous/secure-image/secure-image.component';
import { WelcomeComponent } from '../components/miscellaneous/welcome/welcome.component';
import { NavButtonsComponent } from '../components/navbar/nav-buttons/nav-buttons.component';
import { NavIconComponent } from '../components/navbar/nav-icon/nav-icon.component';
import { NavbarHexagonComponent } from '../components/navbar/navbar-hexagon/navbar-hexagon.component';
import { NavbarComponent } from '../components/navbar/navbar/navbar.component';
import { CreateContactFormComponent } from '../components/organisation-user-settings/views-organisation-management/contact-components/create-contact-form/create-contact-form.component';
import { AddEntriesToListComponent } from '../components/product-certification/shared-subcomponents/addEntriesToList-panel/addEntriesToList-panel.component';
import { InfoBoxComponent } from '../components/product-certification/shared-subcomponents/info-box/info-box.component';
import { VersionInfoBoxComponent } from '../components/product-certification/shared-subcomponents/version-info-box/version-info-box.component';
import { AddProductDependencyPanelComponent } from '../components/products-ptg-dependencies/add-product-dependency-panel/add-product-dependency-panel.component';
import { AddPtgDependencyPanelComponent } from '../components/products-ptg-dependencies/add-ptg-dependency-panel/add-ptg-dependency-panel.component';
import { AddPtgDependencyTableComponent } from '../components/products-ptg-dependencies/add-ptg-dependency-table/add-ptg-dependency-table.component';
import { SelectedProductPanelComponent } from '../components/products-ptg-dependencies/selected-product-panel/selected-product-panel.component';
import { SelectedPtgPanelComponent } from '../components/products-ptg-dependencies/selected-ptg-panel/selected-ptg-panel.component';
import { ReviewsComponent } from '../components/reviews/reviews/reviews.component';
import { StarComponent } from '../components/reviews/star/star.component';
import { WriteReviewComponent } from '../components/reviews/write-review/write-review.component';
import { FilterPanelComponent } from '../components/sidemenu/components-filterpanel-searchpanel/filter-panel/filter-panel.component';
import { RatingPanelComponent } from '../components/sidemenu/components-filterpanel-searchpanel/rating-panel/rating-panel.component';
import { SearchPanelComponent } from '../components/sidemenu/components-filterpanel-searchpanel/search-panel/search-panel.component';
import { SidemenuButtonComponent } from '../components/sidemenu/sidemenu/sidemenu-button/sidemenu-button.component';
import { SidemenuNewComponent } from '../components/sidemenu/sidemenu/sidemenu-new/sidemenu-new.component';
import { CustomMaterialModule } from './app-material-module';
import { CustomPipeModule } from './app-pipe-module';
import { DialogDeleteUserManageOrganisationsComponent } from '../components/dialog-windows/dialog-delete-user-manage-organisations/dialog-delete-user-manage-organisations.component';
import { ToolchainInstanceTableRowComponent } from '../components/composer/composer-overview/toolchain-instance-table-row/toolchain-instance-table-row.component';
import { ToolchainTemplateTableRowComponent } from '../components/composer/composer-overview/toolchain-template-table-row/toolchain-template-table-row.component';
import { ToolchainTemplateTableComponent } from '../components/composer/composer-overview/toolchain-template-table/toolchain-template-table.component';
import { ToolchainInstanceTableComponent } from '../components/composer/composer-overview/toolchain-instance-table/toolchain-instance-table.component';
import { AddSchemaFormComponent } from '../components/compatiblity-features/add-schema-form/add-schema-form.component';
import { ModelViewerComponent } from '../components/composer/model-viewer/model-viewer.component';
import { DialogToolchainInstanceUploadDataComponent } from '../components/composer/dialog-toolchain-instance-upload-data/dialog-toolchain-instance-upload-data.component';
import { ToolchainDetailDisplayComponent } from '../components/marketplace/detail-pages/toolchain-detail-display/toolchain-detail-display.component';
import { PublicActivityItemComponent } from '../components/components-profiles/public-activity-item/public-activity-item.component';
import { PublicReviewComponent } from '../components/components-profiles/public-review/public-review.component';
import { ReviewReportItemComponent } from '../components/reviews/review-report-item/review-report-item.component';
import { HexaconButtonLeftTextIconComponent } from '../components/buttons/hexacon-button-left-text-icon/hexacon-button-left-text-icon.component';
import { VersionCertificationRequestComponent } from '../components/product-certification/products/version-certification-request/version-certification-request.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CertificationRequestOverviewComponent } from '../components/certification-request-shared/certification-request-overview/certification-request-overview.component';
import { CertificationRequestProcessingComponent } from '../components/organisation-user-settings/views-organisation-management/certification-requests/certification-request-processing/certification-request-processing.component';
import { CertificationRequestLogComponent } from '../components/certification-request-shared/certification-request-log/certification-request-log.component';
import { CertificationRequestLogEntryComponent } from '../components/certification-request-shared/certification-request-log/certification-request-log-entry/certification-request-log-entry.component';
import { VersionCertificationRequestStatusComponent } from './../components/product-certification/products/version-certification-request-status/version-certification-request-status.component';
import { StatusDisplayComponent } from '../components/certification-request-shared/status-display/status-display.component';
import { DialogCertReqChangeStatusComponent } from '../components/dialog-windows/dialog-certReq-change-status.component';
import { DialogDelegateCertificationComponent } from '../components/dialog-windows/dialog-delegate-certification.component';
import { DialogConfirmDelegateCertificationComponent } from '../components/dialog-windows/dialog-confirm-delegate-certification.component';
import { DialogFileRequestComponent } from '../components/dialog-windows/dialog-certReq-requestFile.component';
import { ImpressumComponent } from '../components/impressum/impressum.component';
import { AgbComponent } from '../components/agb/agb.component';

import { PrivacyComponent } from '../components/privacy/privacy.component';

import { ImageSliderComponent } from '../components/image-slider/image-slider.component';
import { HeaderComponent } from '../components/miscellaneous/header/header.component';
import { ProfileComponent } from '../components/miscellaneous/header/profile/profile.component';
import { DialogCookieConsentComponent } from '../components/dialog-windows/dialog-cookie-consent/dialog-cookie-consent.component';
import { DialogTarifeComponent } from '../components/dialog-windows/dialog-tarife/dialog-tarife.component';
import { ContactFormComponent } from '../components/organisation-user-settings/views-organisation-management/contact-components/contact-form/contact-form.component';
import { ProductTypeGroupFeatureDisplayComponent } from '../components/marketplace/detail-pages/product-detail-display/product-detail-display-feature/product-type-group-feature-display/product-type-group-feature-display.component';
import { ProductTypeGroupFeatureListComponent } from '../components/marketplace/detail-pages/product-detail-display/product-detail-display-feature/product-type-group-feature-display/product-type-group-feature-list/product-type-group-feature-list.component';
import { UnconfirmedUserManagementComponent } from '../components/organisation-user-settings/views-user-settings/nutzerverwaltung-screen/unconfirmed-user-management/unconfirmed-user-management.component';
import { SearchBarComponent } from '../components/miscellaneous/search-bar/search-bar.component';
import { OrganisationEditComponent } from '../components/organisation-user-settings/organisation-edit/organisation-edit.component';
import { LogoComponent } from '../components/logo/logo.component';
import { ProductFilesComponent } from '../components/product-files/product-files.component';
import { DialogBackendServiceUnavailableComponent } from '../components/dialog-windows/dialog-backend-service-unavailable/dialog-backend-service-unavailable/dialog-backend-service-unavailable.component';
import { DialogFileUploadLoadingComponent } from '../components/dialog-windows/dialog-file-upload-loading/dialog-file-upload-loading.component';
import { DialogInfoComponent } from '../components/dialog-windows/dialog-info/dialog-info.component';
import { DialogCertificateDetailComponent } from '../construct-x/shared/components/dialogs/dialog-certificate-detail/dialog-certificate-detail.component';
import { DialogVcSignatureComponent } from '../construct-x/shared/components/dialogs/dialog-vc-signature/dialog-vc-signature.component';
import { SharedModule } from '../construct-x/shared/shared.module';
import { CertificatesModule } from '../construct-x/wallet/certificates.module';
import { FileUploadComponent } from '../components/file-upload/file-upload.component';
import { SwarmCreditCardComponent } from '../components/zahlung/swarm-credit-card/swarm-credit-card.component';
import { FlipCardOnClickDirective } from '../components/zahlung/swarm-credit-card/flip-card-on-click.directive';
import { ZahlungsPortalComponent } from '../components/zahlung/zahlungs-portal/zahlungs-portal.component';
import { ZahlungsDatenComponent } from '../components/zahlung/zahlungs-portal/zahlungs-daten/zahlungs-daten.component';
import { AbonnementsComponent } from '../components/zahlung/zahlungs-portal/abonnements/abonnements.component';
import { RechnungenComponent } from '../components/zahlung/zahlungs-portal/rechnungen/rechnungen.component';
import { AbonnementPageComponent } from '../components/zahlung/zahlungs-portal/abonnement-page/abonnement-page.component';
import { TarifeComponent } from '../components/zahlung/tarife/tarife.component';
import { AnalyticsComponent } from '../components/analytics/analytics.component';
import { TarifeCardComponent } from '../components/zahlung/tarife/tarife-card/tarife-card.component';
import { RegistryConfirmationComponent } from '../components/registration-login/registration/registry-confirmation/registry-confirmation.component';
import { OrganisationEditSettingsComponent } from '../components/organisation-user-settings/organisation-edit-settings/organisation-edit-settings.component';
import { AboConfirmationComponent } from '../components/zahlung/zahlungs-portal/abo-confirmation/abo-confirmation.component';
import { ProductCreateComponent } from '../components/product-certification/products/products/product-create/product-create.component';
import { RegistryLinkComponent } from '../components/registration-login/registration/registry-link/registry-link.component';
import { RegistryStepsGraficComponent } from '../components/miscellaneous/registry-steps-grafic/registry-steps-grafic.component';
import { RegistryStepsConfirmWrapperComponent } from '../components/registration-login/registration/registry-steps-confirm-wrapper/registry-steps-confirm-wrapper.component';
import { RegistryOrganisationStepsWrapperComponent } from '../components/organisation-user-settings/registry-organisation-steps-wrapper/registry-organisation-steps-wrapper.component';
import { PaymentStepWrapperComponent } from '../components/zahlung/payment-step-wrapper/payment-step-wrapper.component';
import { AboPaymentComponent } from '../components/zahlung/zahlungs-portal/abo-payment/abo-payment.component';
import { TarifCardSelectedComponent } from '../components/zahlung/tarife/tarif-card-selected/tarif-card-selected.component';
import { ProductListItemComponent } from './../components/product-list/product-list-item/product-list-item.component';

import { SitemapComponent } from '../components/sitemap/sitemap.component';
import { ProductDetailDisplayFullComponent } from '../components/marketplace/detail-pages/product-detail-display/product-detail-display-full/product-detail-display-full.component';
import { CommonFeatureCategoriesAddComponent } from '../components/common-feature/common-feature-categories-add/common-feature-categories-add.component';
import { CommonFeatureCategoriesItemComponent } from '../components/common-feature/common-feature-categories-item/common-feature-categories-item.component';
import { CommonFeatureCategoriesListComponent } from '../components/common-feature/common-feature-categories-list/common-feature-categories-list.component';
import { DialogUserReviewHistoryComponent } from '../components/dialog-windows/dialog-user-review-history/dialog-user-review-history.component';
import { UserProfilePublicComponent } from '../components/components-profiles/user-profile-public/user-profile-public.component';
import { ProductDetailDisplayFeatureSummaryComponent } from '../components/marketplace/detail-pages/product-detail-display/product-detail-display-feature-summary/product-detail-display-feature-summary.component';
import { CommonFeatureProductCreationComponent } from '../components/product-certification/products/products/product-screen/common-feature-product-creation/common-feature-product-creation.component';
import { ProductLizenzDialogComponent } from '../components/product-certification/products/products/product-lizenz-dialog/product-lizenz-dialog.component';
import { DialogContractTransfer } from '../components/dialog-windows/dialog-contract-transfer/dialog-contract-transfer.component';
import { XmlPreviewDialogComponent } from '../components/dialog-windows/dialog-xml-preview/dialog-xml-preview.component';

import { TemplateValueEditorComponent } from '../components/product-certification/certifications/certifications/certification-template-editor/template-value-editor/template-value-editor.component';
import { TemplateValueNodeEditorComponent } from '../components/product-certification/certifications/certifications/certification-template-editor/template-value-node-editor/template-value-node-editor.component';
import { DialogJson } from '../components/dialog-windows/dialog-json/dialog-json.component';
import { httpInterceptorProviders } from '../Interceptors/InterceptorArray';
import { UrlValidatorDirective } from '../directives/url-validator.directive';
//St�rungsmanagement

@NgModule({
    declarations: [
        //Analytics
        AnalyticsComponent,
        //Header
        HeaderComponent,
        ProfileComponent,
        SitemapComponent,
        //Components
        ValidationIconComponent,
        AttributeCatalogueComponent,
        PtgAttributeCatalogueComponent,
        AttributeTableComponent,
        WelcomeComponent,
        HexagonComponent,
        AddEntriesToListComponent,
        AttributeSelectTableComponent,
        AttributeValidationTableComponent,
        AttributeValidationPanelComponent,
        InfoBoxComponent,
        VersionInfoBoxComponent,
        SelectedPtgPanelComponent,
        AddPtgDependencyPanelComponent,
        AddPtgDependencyTableComponent,
        AddProductDependencyPanelComponent,
        SelectedProductPanelComponent,
        AttributeValidationComponent,
        DigitOnlyDirective,
        CreateContactFormComponent,
        VersionEditComponent,
        TextEditorComponent,
        FileDropDirective,
        UrlValidatorDirective,
        PasswordStrengthComponent,
        OrganisationEditComponent,
        OrganisationContactOverviewComponent,
        FileUploadComponent,
        AttributeOverviewComponent,
        RegistryConfirmationComponent,
        OrganisationEditSettingsComponent,
        AboConfirmationComponent,
        ProductCreateComponent,
        RegistryLinkComponent,
        RegistryStepsGraficComponent,
        RegistryStepsConfirmWrapperComponent,
        RegistryOrganisationStepsWrapperComponent,
        PaymentStepWrapperComponent,
        AboPaymentComponent,
        TarifCardSelectedComponent,
        ProductListItemComponent,
        //NavBar
        NavbarComponent,
        NavButtonsComponent,
        NavbarHexagonComponent,
        NavIconComponent,
        //Sidemenu
        SearchPanelComponent,
        RatingPanelComponent,
        FilterPanelComponent,
        HexLabelItemComponent,
        SidemenuNewComponent,
        SidemenuButtonComponent,
        //Buttons
        HexagonButtonTextIconComponent,
        HexLabelButtonComponent,
        TriangleIndentComponent,
        RedCrossButtonComponent,
        RedCrossButtonCircleComponent,
        RedTrashCanButtonComponent,
        ToggleSwitchComponent,
        CheckboxSwitchComponent,
        RoundedButtonComponent,
        SquaredButtonComponent,
        HexaconButtonLeftTextIconComponent,
        GreenPlusButtonComponent,
        //Marktplatz
        MarketplaceCategorySwitchComponent,
        MarketplaceProducthexagonComponent,
        MarketplaceSideimagehexagonComponent,
        MarketPlaceSideFilterComponent,
        WriteCommentComponent,
        MarketplaceProductRondellComponent,
        //
        CertificationDetailDisplayComponent,
        CertificationDetailDisplayOverviewComponent,
        CertificationDetailDisplayOrganisationComponent,
        CertificationDetailDisplayCriteriaComponent,
        StatusDisplayComponent,
        //
        DisplayItemComponent,
        OrganisationDetailDisplayComponent,
        ProductDetailDisplayComponent,
        MarketplaceOverviewComponent,
        CertificateMiniDisplayComponent,
        CertificateSimpleDisplayComponent,
        ReviewTableComponent,
        ReviewReportItemComponent,
        //
        DetailDisplayHeaderComponent,
        DetailDisplayGalleryComponent,
        MarketplaceRatingExtendedComponent,
        CommentItemComponent,
        //
        ProductDetailDisplayOverviewComponent,
        ProductDetailDisplayFeatureComponent,
        ProductTypeGroupFeatureDisplayComponent,
        ProductTypeGroupFeatureListComponent,
        ProductDetailDisplayDownloadsComponent,
        ProductDetailDisplayCertificatesComponent,
        ProductDetailDisplayOrganisationComponent,
        ProductDetailDisplayCommonFeaturesComponent,
        DetailDisplayDocumentListComponent,
        DetailDisplayContactDisplayComponent,
        OrganisationContactOverviewComponent,
        DetailDisplayAdressDisplayComponent,
        ProductFilesComponent,
        ProductDetailDisplayFullComponent,
        ProductDetailDisplayFeatureSummaryComponent,
        UserProfilePublicComponent,
        ProductSummaryComponent,
        //
        ToolchainDetailDisplayComponent,
        //Bewertung
        WriteReviewComponent,
        StarComponent,
        ReviewsComponent,
        CommentTableComponent,
        WriteReviewComponent,
        StarComponent,
        CommentItemComponent,
        //Divers
        HmtlDisplayComponent,
        //Footer
        FooterComponent,
        //Dialog
        DialogOverviewExampleDialogComponent,
        DialogAttributeCreate,
        DialogText,
        DialogAgb,
        DialogContractTransfer,
        DialogPrivacy,
        DialogFileManagerComponent,
        DialogRemoveMemberConfirmComponent,
        DialogConfirmComponent,
        DialogCommonFeatureProductCreationComponent,
        DialogRequestComponent,
        DialogCertRequestComponent,
        DialogAddProductToNodeComponent,
        DialogEditMetaDataComponent,
        DialogDeleteUserManageOrganisationsComponent,
        DialogToolchainInstanceUploadDataComponent,
        DialogCertReqChangeStatusComponent,
        DialogDelegateCertificationComponent,
        DialogConfirmDelegateCertificationComponent,
        DialogFileRequestComponent,
        DialogCookieConsentComponent,
        DialogBackendServiceUnavailableComponent,
        DialogFileUploadLoadingComponent,
        DialogInfoComponent,
        DialogLoginComponent,
        DialogErrorComponent,
        DialogUserReviewHistoryComponent,
        ProductLizenzDialogComponent,
        //SecureImage
        SecureImageComponent,
        ImageSliderComponent,
        ImpressumComponent,
        AgbComponent,
        PrivacyComponent,
        FilemanagerComponent,
        //Produktlist
        ProductListComponent,
        //Stoerungsmanagement
        MalfunctionOverviewComponent,
        ReportMalfunctionScreenComponent,
        MalfunctionOverviewOrganisationComponent,
        //Zertifizierung
        VersionCertificationRequestComponent,
        VersionCertificationRequestStatusComponent,
        CertificationRequestLogComponent,
        CertificationRequestLogEntryComponent,
        CertificationRequestOverviewComponent,
        CertificationRequestProcessingComponent,
        //Misc
        ProfilePictureComponent,
        UnconfirmedUserManagementComponent,
        SearchBarComponent,
        LogoComponent,
        //Common Features
        CommonFeatureAddComponent,
        CommonFeatureItemComponent,
        CommonFeatureItemEditFormComponent,
        CommonFeatureCategoriesAddComponent,
        CommonFeatureCategoriesItemComponent,
        CommonFeatureCategoriesListComponent,
        CommonFeatureProductCreationComponent,
        //Composer
        ModelEditorComponent,
        ComposerProductFilterElementComponent,
        ComposerProductOverviewComponent,
        ToolchainInstanceTableRowComponent,
        ToolchainTemplateTableRowComponent,
        ToolchainTemplateTableComponent,
        ToolchainInstanceTableComponent,
        ModelViewerComponent,
        // Compatiblity Service
        AddSchemaFormComponent,
        //Public Profile
        PublicActivityItemComponent,
        PublicReviewComponent,
        ContactFormComponent,
        // Zahlung Portal Componenets
        SwarmCreditCardComponent,
        FlipCardOnClickDirective,
        ZahlungsPortalComponent,
        ZahlungsDatenComponent,
        AbonnementsComponent,
        RechnungenComponent,
        AbonnementPageComponent,
        TarifeComponent,
        TarifeCardComponent,
        DialogTarifeComponent,
        DialogAboVerwaltungComponent,
    ],
    exports: [
        //Header
        HeaderComponent,
        ProfileComponent,
        //Modules
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        CustomMaterialModule,
        CustomPipeModule,
        //Components
        ImageSliderComponent,
        ImpressumComponent,
        AgbComponent,
        PrivacyComponent,
        SecureImageComponent,
        ValidationIconComponent,
        AttributeCatalogueComponent,
        PtgAttributeCatalogueComponent,
        AttributeTableComponent,
        WelcomeComponent,
        AttributeSelectTableComponent,
        AttributeValidationTableComponent,
        AttributeValidationPanelComponent,
        InfoBoxComponent,
        VersionInfoBoxComponent,
        SelectedPtgPanelComponent,
        AddPtgDependencyPanelComponent,
        AddPtgDependencyTableComponent,
        AddEntriesToListComponent,
        AddProductDependencyPanelComponent,
        SelectedProductPanelComponent,
        HexagonComponent,
        PasswordStrengthComponent,
        ReviewReportItemComponent,
        FileUploadComponent,
        AttributeOverviewComponent,
        RegistryStepsGraficComponent,
        ProductCreateComponent,
        ProductSummaryComponent,
        //FileManagementSystem
        FilemanagerComponent,
        AttributeValidationComponent,
        DigitOnlyDirective,
        UrlValidatorDirective,
        CreateContactFormComponent,
        VersionEditComponent,
        TextEditorComponent,
        OrganisationEditComponent,
        OrganisationContactOverviewComponent,
        ProductFilesComponent,
        //NavBar
        NavbarComponent,
        NavButtonsComponent,
        NavbarHexagonComponent,
        NavIconComponent,
        //Sidemenu
        SearchPanelComponent,
        RatingPanelComponent,
        FilterPanelComponent,
        HexLabelItemComponent,
        SidemenuNewComponent,
        SidemenuButtonComponent,
        //Buttons
        HexagonButtonTextIconComponent,
        HexLabelButtonComponent,
        TriangleIndentComponent,
        RedCrossButtonComponent,
        RedCrossButtonCircleComponent,
        ToggleSwitchComponent,
        CheckboxSwitchComponent,
        RoundedButtonComponent,
        SquaredButtonComponent,
        GreenPlusButtonComponent,
        //Marktplatz
        MarketplaceProducthexagonComponent,
        MarketplaceSideimagehexagonComponent,
        MarketPlaceSideFilterComponent,
        InfiniteScrollComponent,
        DragulaModule,
        WriteCommentComponent,
        WriteReviewComponent,
        StarComponent,
        CommentItemComponent,
        DisplayItemComponent,
        HmtlDisplayComponent,
        //Footer
        FooterComponent,
        //Stoerungsmanagement
        MalfunctionOverviewComponent,
        OrganisationContactOverviewComponent,
        //Misc
        ProfilePictureComponent,
        UnconfirmedUserManagementComponent,
        SearchBarComponent,
        LogoComponent,
        //Common Feature
        CommonFeatureAddComponent,
        CommonFeatureItemComponent,
        CommonFeatureItemEditFormComponent,
        CommonFeatureProductCreationComponent,
        //Composer
        ModelEditorComponent,
        ComposerProductFilterElementComponent,
        ComposerProductOverviewComponent,
        ToolchainInstanceTableRowComponent,
        ToolchainTemplateTableRowComponent,
        ToolchainTemplateTableComponent,
        ToolchainInstanceTableComponent,
        // Compatiblity Service
        AddSchemaFormComponent,
        ModelViewerComponent,
        //Public Profile
        PublicActivityItemComponent,
        PublicReviewComponent,
        //Certification
        StatusDisplayComponent,
        ContactFormComponent,
        XmlPreviewDialogComponent,
        CertificationDetailDisplayCertifiedOrganisationsComponent,
        ContactFormComponent,
        // Certification Template Editor
        CertificationTemplateEditorComponent,
        TemplateNodeEditorComponent,
        TemplateTreeViewerComponent,
        TemplateValueEditorComponent,
        TemplateValueNodeEditorComponent,
        DragDropModule
    ], imports: [
        CommonModule,
        LayoutModule,
        QuillModule.forRoot(),
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        CustomMaterialModule,
        CustomPipeModule,
        NgxChartsModule,
        MatButtonToggleModule,
        DragulaModule.forRoot(),
        ScrollingModule,
        DragDropModule,
        SharedModule,
        CertificatesModule,
        InfiniteScrollComponent,
        CertificationDetailDisplayCertifiedProductsComponent,
        CertificationDetailDisplayCertifiedOrganisationsComponent,
        AssetPropertiesDialogComponent,
        DialogCertificateDetailComponent,
        DialogVcSignatureComponent,
        DialogJson,
        XmlPreviewDialogComponent,
        // Certification Template Editor
        CertificationTemplateEditorComponent,
        TemplateNodeEditorComponent,
        TemplateTreeViewerComponent,
        TemplateValueEditorComponent,
        TemplateValueNodeEditorComponent
    ],
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideHttpClient(withInterceptorsFromDi()),
        httpInterceptorProviders,
        DatePipe
    ]
})
export class CustomComponentModule { }
